/**
 * Check whether a value is null or undefined.
 *
 * @param {*} value Value to check.
 * @return {boolean} Whether the value is nullish.
 */
export function isNullish(value) {
  return value === null || value === undefined;
}
